import React, { useState } from 'react';
import { safeRest } from '@wds/utils';
import { Accordion } from '@wds/accordion';
import { Responsive } from '@wds/responsive';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { t, defineMessages } from '@sm/intl';
import ProductsMenu from './ProductsMenu';
import HelpMenu from './HelpMenu';
import useStyles from './useStyles';

const COPY = defineMessages({
  HELP: {
    id: 'InfoMenu.help',
    defaultMessage: 'Help',
    description:
      '[Type: Label][Vis.: high] - This is the Help title of the side menu.',
  },
  PRODUCTS: {
    id: 'InfoMenu.products',
    defaultMessage: 'Products',
    description:
      '[Type: Label][Vis.: high] - This is the Products title of the side menu.',
  },
});

const InfoMenu = ({ ...rest }) => {
  const classes = useStyles();
  const [showProducts, setShowProducts] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const toggleProducts = () => {
    setShowHelp(false);
    setShowProducts(!showProducts);
  };

  const toggleHelp = () => {
    setShowProducts(false);
    setShowHelp(!showHelp);
  };

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <>
              <div className={classes.infoMenu} {...safeRest(rest)}>
                <ProductsMenu
                  showProducts={showProducts}
                  toggleProducts={toggleProducts}
                />
              </div>
              <div className={classes.infoMenu} {...safeRest(rest)}>
                <HelpMenu showHelp={showHelp} toggleHelp={toggleHelp} />
              </div>
            </>
          ) : (
            <>
              <Accordion noRules interactive>
                <Accordion.Item title={t(COPY.PRODUCTS)}>
                  <List noRules interactive transparent>
                    <Box className={classes.subNavMenu}>
                      <ProductsMenu
                        showProducts={showProducts}
                        toggleProducts={toggleProducts}
                      />
                    </Box>
                  </List>
                </Accordion.Item>
                <Accordion.Item title={t(COPY.HELP)}>
                  <List noRules interactive transparent>
                    <Box className={classes.subNavMenu}>
                      <HelpMenu showHelp={showHelp} toggleHelp={toggleHelp} />
                    </Box>
                  </List>
                </Accordion.Item>
              </Accordion>
            </>
          )
        }
      </Responsive>
    </>
  );
};

export default InfoMenu;
export { InfoMenu };
